import styles from '../StoredCreditCards/StoredCreditCards.module.scss';

import { Nullable } from '@types-internal';

export type CreditCardNumberProps = {
  lastFourDigits: Nullable<string>;
  ['data-zta']?: string;
};

/**
 * Display 16 dots which stands for the credit card number.
 * If lastFourDigits is a non-empty string, display 12 dots + these lastFourDigits.
 */
const MaskedCardNumber: React.FC<CreditCardNumberProps> = ({
  lastFourDigits,
  ['data-zta']: dataZta,
}) => {
  // If we have the lastFourDigits, then we display them. Otherwise, we display only dots.
  const indexesBlock = lastFourDigits ? [1, 2, 3] : [1, 2, 3, 4];
  return (
    <div className={styles.creditCardDotsContainer}>
      {indexesBlock.map((indexBlock) => (
        <span className={styles.creditCardDots} key={indexBlock}>
          {[1, 2, 3, 4].map((indexDot) => (
            <span key={indexDot} className={styles.creditCardDot}>
              &#11044;
            </span>
          ))}
        </span>
      ))}
      {lastFourDigits && <span data-zta={dataZta}>{lastFourDigits}</span>}
    </div>
  );
};

export default MaskedCardNumber;
